import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges, inject } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { validateNumber } from '../../validators/numeric-input.validator';
import { FormParser } from '../../providers/form-parser.service';
import { validateHexColor } from '../../validators/hex-color.validator';
import { SpotLightComponent } from 'projects/visualize3d/src/public-api';

type SpotlightForm = {
  color: FormControl<string>;
  intensity: FormControl<number>;
  angle: FormControl<number>;
  castShadow: FormControl<boolean>;
  decay: FormControl<number>;
  distance: FormControl<number>;
  penumbra: FormControl<number>;
};

@Component({
  selector: 'app-spot-light-editor',
  templateUrl: './spot-light-editor.component.html',
  styleUrls: ['./spot-light-editor.component.css'],
  standalone: false,
})
export class SpotLightEditorComponent implements OnChanges {
  private fb = inject(FormBuilder);
  private parser = inject(FormParser);

  @Input() component: SpotLightComponent;
  @Output() componentChange = new EventEmitter<void>();
  form: FormGroup<SpotlightForm>;

  constructor() {
    const fb = this.fb;

    this.form = fb.group({
      color: ['', validateHexColor],
      intensity: [0, validateNumber],
      angle: [0, validateNumber],
      castShadow: [false],
      decay: [0, validateNumber],
      distance: [0, validateNumber],
      penumbra: [0, validateNumber],
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.component && changes.component.currentValue) {
      this.form.controls.color.setValue(changes.component.currentValue.color, { emitEvent: false });
      this.form.controls.intensity.setValue(changes.component.currentValue.intensity, { emitEvent: false });
      this.form.controls.angle.setValue(changes.component.currentValue.angle, { emitEvent: false });
      this.form.controls.castShadow.setValue(changes.component.currentValue.castShadow, { emitEvent: false });
      this.form.controls.decay.setValue(changes.component.currentValue.decay, { emitEvent: false });
      this.form.controls.distance.setValue(changes.component.currentValue.distance, { emitEvent: false });
      this.form.controls.penumbra.setValue(changes.component.currentValue.penumbra, { emitEvent: false });
    }
  }

  onSubmit(): void {
    this.component.color = this.form.controls.color.value;
    this.component.intensity = this.parser.parseNumber(this.form.controls.intensity);
    this.component.angle = this.parser.parseNumber(this.form.controls.angle);
    this.component.castShadow = this.form.controls.castShadow.value;
    this.component.decay = this.parser.parseNumber(this.form.controls.decay);
    this.component.distance = this.parser.parseNumber(this.form.controls.distance);
    this.component.penumbra = this.parser.parseNumber(this.form.controls.penumbra);
    this.componentChange.next();
  }
}
